import type { NinetailedExperiences } from '../types'
export const ninetailedExperienceData: NinetailedExperiences = [
  {
    "id": "7KPQRmh6VMoUcQ9zWqnAVu",
    "name": "All | US | BMS | System Advisor - Plan Selection"
  },
  {
    "id": "1c9CEqWqWMDYKViD1lH69H",
    "name": "ALL | US | Sitewide | AI Chat Bot"
  },
  {
    "id": "2zieO8MBstjY4xgNy1ps1m",
    "name": "Uber Entry - Ninetailed Experience"
  },
  {
    "id": "5P2m2qxA7dqtTRZRalA3bu",
    "name": "All | US | Cart | Strikethrough Pricing"
  },
  {
    "id": "7I97UdfgvBzEwWDMdnDz3l",
    "name": "All | US | BMS PDP | Open New Tab"
  },
  {
    "id": "5hAHZ9TjK3nFwrrTxTEN1Y",
    "name": "All | US | Payment | PayPal"
  },
  {
    "id": "1pODwgBAbTnkcfTSi3tNOx",
    "name": "All | US | Alarm Sensors | Existing Customer Promo Banner"
  },
  {
    "id": "5K0TjVx73XDwXVhfFDFmdH",
    "name": "All | US | BMS | System Advisor MVP"
  },
  {
    "id": "73sED4HpsmuG0HqpSuFtD6",
    "name": "All | US | BMS | SMS Redesign"
  },
  {
    "id": "5DJqGRkudtnuXa2IYDPzn7",
    "name": "All | US | HP/LP | Dogs in Hero"
  },
  {
    "id": "1svFAjIeTPu6XHB15XXKmA",
    "name": "All | US | Cart | ODMON Remove Change Plan"
  },
  {
    "id": "5jbKWShnFO26rrTqB0KPhI",
    "name": "All | US | Sitewide | ODMON Full Launch"
  },
  {
    "id": "4GEbpLApsFPnwEwIA9nFul",
    "name": "All | US | LP | Camera-Only LP CTA"
  },
  {
    "id": "2bd5utj9AeJRbTqPT9brTE",
    "name": "All | US | Nav | Monitoring and Phone"
  },
  {
    "id": "3qWAwHpBvgc3q7kYcF1tKd",
    "name": "All | US | Cart | Shop Now CTA Destination"
  },
  {
    "id": "3cc5mMtyXMnxx8plBFJS7d",
    "name": "All | US | Quiz | ODMON Intent Question"
  },
  {
    "id": "6D8kWBgaSOmBJTqoSp6WaY",
    "name": "All | US | BMS | BMS v3"
  },
  {
    "id": "4KV0xCdcOPZCsHE440sphE",
    "name": "AlL | US | Sitewide | BMSM v3 "
  },
  {
    "id": "2tJZSbjXImmWYG7g842gwI",
    "name": "Uber"
  },
  {
    "id": "74oRcO8p2ocl99pA8k7kEk",
    "name": "All | US | Sitewide | ODMON Full Launch - Personalization"
  },
  {
    "id": "5hKV8acNbHRzAJdWjLUZRi",
    "name": "All | US | Package | Price Above Fold"
  },
  {
    "id": "1ciqW5mb6OoYY7EUgzw0kx",
    "name": "All | US | Plan Choice - Dynamic Non-Intent Stay | ODMON Hybrid Experience"
  },
  {
    "id": "6uLidXzWkBx2S85lGA4Ytr",
    "name": "All | US | Plan Choice - Non-Camera Stay | ODMON Hybrid Experience"
  },
  {
    "id": "1BD0u0BTtLHeTevjj30Sca",
    "name": "All | US | HP/LP | Dog Ad Replace ODMON Video"
  },
  {
    "id": "3Io2DGjeySkKzQdS1aPA4r",
    "name": "All | US | Plan Choice - Dynamic Non-Intent Push | ODMON Hybrid Experience"
  },
  {
    "id": "2h8RueDaHIvibJJ8W9pidg",
    "name": "All | US | Plan Choice - Non-Camera Push | ODMON Hybrid Experience"
  },
  {
    "id": "4Sz4DUU5wONgxgYPQ7BrsE",
    "name": "All | US | Plan Choice - Dynamic Intent Stay | ODMON Hybrid Experience"
  },
  {
    "id": "37VxKVHi77ofMv5DZeuKjZ",
    "name": "All | US | Plan Choice - Dynamic Intent Push | ODMON Hybrid Experience"
  },
  {
    "id": "2ZqVIPgWWSMzkzupjCltMG",
    "name": "All | US | Plan Choice | ODMON Hybrid Experience"
  },
  {
    "id": "2x8nA3HAn0tomT0XfNOrHP",
    "name": "All | US | Sitewide | ODMON Intender Quiz"
  },
  {
    "id": "4jg5cmOXvQ9ibr3gZIs3Ep",
    "name": "All | US | Dynamic Packages | ODMON Experience"
  },
  {
    "id": "5UKb12DRJSUCFUNuFwQsB1",
    "name": "Cydcor Affirm Experience"
  },
  {
    "id": "5cotDtTFDkqNsG585AEnVs",
    "name": "All | US | Sitewide | Phone Capture in Promo Banner 2"
  },
  {
    "id": "1cN1KR15ATU7bloNSnKoNQ",
    "name": "All | US | HP LP | New Brand Hero Copy"
  },
  {
    "id": "ywGrrlponBX5q8WUmOjYA",
    "name": "All | US | HP/LP | Hide Video and Affirm Banners"
  },
  {
    "id": "4HaFKfL7XyQFiSllKCzamf",
    "name": "All | US | Sitewide | Affirm 36 Month Test"
  },
  {
    "id": "6ahf8pkazximVAkWrWZ5xg",
    "name": "All | US | Sitewide | ODMON Pre-Launch Test"
  },
  {
    "id": "2nkf8aswVqprkbzj1JeaYa",
    "name": "[POC] BMS Guarantee Image"
  }
]